export const MANAGER_COCKPIT_TOUR_NAMESPACE = 'jbp-manager-cockpit-tour'

// i18n key registry for the manager cockpit widget tour, apart from the single-partner tour's
// keys. Step keys are named after what the step shows rather than its position, so reordering the
// tour does not orphan them.
export const MANAGER_COCKPIT_TOUR_TRANSLATION_KEYS = {
  tourButton: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-tour-button`,
  steps: {
    welcome: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-welcome-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-welcome-description`,
    },
    sectionRail: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-section-rail-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-section-rail-description`,
    },
    filterPanel: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-filter-panel-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-filter-panel-description`,
    },
    scopePanel: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-panel-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-panel-description`,
    },
    revenueTile: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-revenue-tile-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-revenue-tile-description`,
    },
    initiativesTile: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-tile-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-tile-description`,
    },
    attentionTile: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-attention-tile-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-attention-tile-description`,
    },
    documentsTile: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-documents-tile-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-documents-tile-description`,
    },
    overviewFork: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-overview-fork-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-overview-fork-description`,
      next: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-overview-fork-next`,
      dismiss: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-overview-fork-dismiss`,
    },
    filterRtm: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-filter-rtm-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-filter-rtm-description`,
    },
    filterOptions: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-filter-options-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-filter-options-description`,
    },
    scopeBar: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-bar-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-bar-description`,
    },
    scopeFiscalYear: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-fiscal-year-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-fiscal-year-description`,
    },
    statusCompleteness: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-status-completeness-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-status-completeness-description`,
    },
    statusAcknowledgment: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-status-acknowledgment-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-status-acknowledgment-description`,
    },
    statusPlanQuality: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-status-plan-quality-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-status-plan-quality-description`,
    },
    scopePeriod: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-period-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-period-description`,
    },
    scopeMetric: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-metric-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-metric-description`,
    },
    scopeCurrency: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-currency-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-scope-currency-description`,
    },
    trainingCentre: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-training-centre-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-training-centre-description`,
    },
    programmeTabs: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-programme-tabs-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-programme-tabs-description`,
    },
    categoryChip: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-category-chip-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-category-chip-description`,
    },
    revenueDetail: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-revenue-detail-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-revenue-detail-description`,
    },
    revenueQuality: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-revenue-quality-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-revenue-quality-description`,
    },
    initiativesList: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-list-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-list-description`,
    },
    initiativesMdf: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-mdf-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-mdf-description`,
    },
    initiativesQuality: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-quality-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-initiatives-quality-description`,
    },
    attentionDetail: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-attention-detail-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-attention-detail-description`,
    },
    documentsDetail: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-documents-detail-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-documents-detail-description`,
    },
    finish: {
      title: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-finish-title`,
      description: `${MANAGER_COCKPIT_TOUR_NAMESPACE}-finish-description`,
    },
  },
}
